"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
/* eslint-disable react/button-has-type */
const ButtonComponent = (props) => {
    const { id, children, color, className, onClick, type, disabled, disabledText } = props;
    let text = children;
    if (disabled && disabledText)
        text = disabledText;
    return (react_1.default.createElement("button", { type: type, id: id, onClick: onClick, className: `btn btn-${color} ${className}`, disabled: disabled }, text));
};
ButtonComponent.propTypes = {
    id: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    type: prop_types_1.default.string,
    color: prop_types_1.default.string,
};
ButtonComponent.defaultProps = {
    type: 'button',
    color: 'primary',
    className: '',
};
exports.Button = ButtonComponent;
//# sourceMappingURL=Button.js.map